module.exports = __webpack_public_path__ + "img/AdsBridge.9e97d5e9.png";